import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../../widgets/Toolbar';
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import { ViewContainer } from "./../../../View.jsx";
import ViewUtils from "../../../ViewUtils";
import AlertItem from "../../../widgets/AlertItem";
import { AddEditTrancheForm } from './AddEditTrancheForm';



const TrancheRef = React.createRef();
const utils = new ViewUtils();
const toolbarRef = React.createRef();

class AddEditTranche extends Component {

    state = {
        /*Deciding on unique identifier for existing tranche details title*/
        TrancheDetails: {
            Description: "",
            Code: ""
        },
        messageStyle: "message",
        id: null,
        showTable: true,
        TrancheID: this.props.location.state.TrancheID,
        hideFields: this.props.location.state.hideFields
    };

    toolbarConfig = {
        items: [

            {
                type: "buttonGroup",
                buttons: [
                    { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                ]
            },
            {
                type: "devider"
            },
            {

                type: "buttonGroup",
                buttons: [
                    { id: 'save', label: 'Submit', tooltip: 'Submit', icon: 'SaveIcon' },
                    { id: 'resubmit', label: 'Re-Submit', tooltip: 'Re-Submit', disabled: this.state.hideFields },
                    { id: 'tranchedetail', label: 'Tranche Details', tooltip: 'Edit Tranche Details', disabled: this.state.hideFields },

                ]
            }

        ]
    };

    handleFormValueChange = (values) => {
        if (!utils.isNull(values)) {
        }
    }


    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        } else if ("close" === buttonId) {
            this.closeView();
        } else if ("resubmit" === buttonId) {
            this.resubmit();
        } else if ("tranchedetail" === buttonId) {
            this.props.history.push({
                pathname: '/TrancheDetails',
                state: {
                    GrantID: this.state.TrancheID
                }
            })
        }
    }

    successCallback(response)  {
        if (response.MessageType === "SUCCESS") {
            this.setState({
                showTable: false
            }, () => {
                this.setState({
                    showTable: true,
                    message: response.Message,
                    messageStyle: response.MessageType,
                    TrancheID: response.EntityId
                })
            });
            toolbarRef.current.setButtonDisabled("resubmit", false);
            toolbarRef.current.setButtonDisabled("tranchedetail", false);
        }
        else {
            this.setState({
                message: response.Message, messageStyle: response.MessageType
            });
        }
    }

    save() {
        let formValue = TrancheRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {
            let input = JSON.stringify(formValue);
            let trancheData = {};
            trancheData.data = input;

            utils.invokeUrl("api/sims/GrantSetup/grantSetupDetailsSubmit", (response) => {
                utils.showMessage(this, response.Message, response.MessageType);
                this.successCallback(response)
            },
                null,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + localStorage.getItem("token")
                    },
                    body: JSON.stringify(trancheData)
                }
            );
        }
    }

    resubmit() {
        let formValue = TrancheRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {
            let input = JSON.stringify(formValue);
            let trancheData = {};
            trancheData.data = input;

            utils.invokeUrl("api/sims/GrantSetup/GrantSetupDetailsReSubmit", (response) => {
                utils.showMessage(this, response.Message, response.MessageType);
                this.successCallback(response)
            },
                null,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + localStorage.getItem("token")
                    },
                    body: JSON.stringify(trancheData)
                }
            );
        }
    }

    closeView() {
        this.props.history.push({
            pathname: '/GrantSetupSearch'
        });
    }

    render() {
        return (
            <ViewContainer topPadding="0" title="">
            <p className="breadcrumbs">
                {"Grant Setup Details"}
            </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false}
                                    title=""
                                    buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    ref={toolbarRef}
                                    config={this.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "65%", maxHeight: "80vh" }}>
                                    {this.state.showTable === true && (
                                        <AddEditTrancheForm ref={TrancheRef}
                                            viewRef={this}
                                            id={this.state.TrancheID}
                                            hideFields={this.state.hideFields}
                                            valueChangeHandler={(values) => this.handleFormValueChange(values)} />
                                    )}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(AddEditTranche);
